import React from "react";
import {withTranslation} from "react-i18next";
import {
    ArrowRightOutlined,LeftOutlined
} from '@ant-design/icons';
import "../cervo.scss";
import {Button} from 'antd';
import {history} from '_helpers/history'
import luxs from "assets/img/LUX_SORPRENDIDA.png";

import sombra from "assets/img/luxsombra.png"
import Headerbutton from "../../../component/headerButton";
import localOrSessionStore from "_helpers/localOrSessionStore";
import variables from "_constants/variables";

function StepCervoFour(props) {
    const storage = localOrSessionStore({ key: variables.REMEMBER });
    const user = JSON.parse(storage.getItem(variables.USER));
    const {t} =props;


    const saveAndContinue = () => {
        history.push("/admin/assessment")
    }

    return (

      <div className={"containerStartCervoTwo wrapper history containerStartCervoTwo--doors"}>
          <div className={"insideCeiba boxed"}>
              <Headerbutton  saveAndContinue={saveAndContinue}  />
          </div>
          <div className={"container-history boxed"}>
              <img className={"character character--lux character--center"} src={luxs} alt={""} />
              <div className={"container-dialogue"}>
                  <div className={"dialogue-content-text"}>
                      <p className={"dialogue-text"} dangerouslySetInnerHTML={{__html: t('cervo.porfinllegado')}}></p>
                      <p className={"dialogue-text"} dangerouslySetInnerHTML={{__html: t('cervo.porfinllegado2')}}></p>
                      <p className={"dialogue-text"} dangerouslySetInnerHTML={{__html: t('cervo.porfinllegado3')}}></p>
                  </div>
                  <div className={"dialogue-buttons"}>
                      <div className="left margin-right-auto">
                          <Button
                            icon={<LeftOutlined />}
                            type={"link"}
                            onClick={() => props.goTo(4)}
                          >
                              {t("atras")}
                          </Button>
                      </div>
                      <div className="right">
                          <Button icon={<ArrowRightOutlined />}
                                  onClick={() => history.push("/admin/cervo-instructions")}
                                  type={"primary"}
                                  className="primaryButton"
                          >
                              {t("cervo.tendremosir")}
                          </Button>
                      </div>
                  </div>
                  <p className={"dialogue-name"}>
                      <strong>LUX</strong>
                  </p>
              </div>
          </div>
      </div>

    )
}

export default withTranslation()(StepCervoFour);
